// Header JS
const headerSection = document.querySelector('.site-header');
const toggleButton = document.querySelector('.js-menu-toggle');
const menu = document.querySelector('.mobile-menu');
const iconMenu = document.querySelector('.icon-menu');
const iconClose = document.querySelector('.icon-close');

let savedBannerClass = '';

function setTextColorFromImage(step) {
  const img = document.querySelector('.banner-wrap__right figure img');
  if (!img) return;

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  img.crossOrigin = "Anonymous";
  img.onload = () => {
    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;
    ctx.drawImage(img, 0, 0);

    const { data } = ctx.getImageData(0, 0, canvas.width, canvas.height);

    let r = 0, g = 0, b = 0, count = 0;

    for (let i = 0; i < data.length; i += 4 * step) {
      r += data[i];
      g += data[i + 1];
      b += data[i + 2];
      count++;
    }

    r /= count;
    g /= count;
    b /= count;

    const luminance =
      0.2126 * (r / 255) +
      0.7152 * (g / 255) +
      0.0722 * (b / 255);

    const body = document.body;
    body.classList.remove('banner-dark', 'banner-light');

    if (luminance > 0.6) {
      body.classList.add('banner-dark');
      savedBannerClass = 'banner-dark';
    } else {
      body.classList.add('banner-light');
      savedBannerClass = 'banner-light';
    }
  };
}

setTextColorFromImage(10);

toggleButton.addEventListener('click', () => {
  menu.style.opacity = 1;
  menu.classList.toggle('open');
  iconMenu.classList.toggle('hide');
  iconClose.classList.toggle('hide');

  if (menu.classList.contains('open')) {
    document.body.style.overflow = 'hidden';
    headerSection.classList.add('not-opaque-top');

    // remove banner class when menu is open
    document.body.classList.remove('banner-dark', 'banner-light');
  } else {
    document.body.style.overflow = '';
    headerSection.classList.remove('not-opaque-top');

    // restore saved banner class
    if (savedBannerClass) {
      document.body.classList.add(savedBannerClass);
    }
  }
});

function checkWindowScroll() {
  if (window.scrollY > 15) {
    headerSection.classList.add('not-opaque');
  } else {
    headerSection.classList.remove('not-opaque');
  }
}

window.addEventListener('scroll', () => {
  checkWindowScroll();
});
checkWindowScroll();


// Header Product Show on Hover
const headerItems = document.querySelectorAll('.site-header__menu-item');

headerItems.forEach(headerItem => {
const items = headerItem.querySelectorAll('.megamenu__links a');
const products = headerItem.querySelectorAll('.megamenu__right');

items.forEach(item => {
  item.addEventListener('mouseenter', () => {
    const targetId = item.getAttribute('data-target');
    const targetElement = headerItem.querySelector(`#${targetId}`);

    if (targetElement) {
      // remove only inside this header item
      items.forEach(l => l.classList.remove('active'));
      products.forEach(p => p.classList.remove('product-active'));

      // activate current
      item.classList.add('active');
      targetElement.classList.add('product-active');
    }
  });
  });
});

// Header JS Ends


let duration = 300;

function isVisible(el) {
  return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
}

function slideUp(element, duration = 300, parent = null) {
  element.style.height = element.offsetHeight + 'px';
  element.offsetHeight; // force repaint
  element.style.transition = `height ${duration}ms ease`;
  element.style.height = 0;
  if (parent) parent.classList.remove('is-open');

  setTimeout(() => {
    element.style.display = 'none';
    element.style.removeProperty('height');
    element.style.removeProperty('transition');
  }, duration);
}

function slideDown(element, duration = 300, parent = null) {
  element.style.removeProperty('display');
  if (getComputedStyle(element).display === 'none') {
    element.style.display = 'block';
  }

  let height = element.scrollHeight;
  element.style.height = '0px';
  element.offsetHeight;
  element.style.transition = `height ${duration}ms ease`;
  element.style.height = height + 'px';
  if (parent) parent.classList.add('is-open');

  setTimeout(() => {
    element.style.removeProperty('height');
    element.style.removeProperty('transition');
  }, duration);
}

// Accordion logic
if (document.querySelectorAll('.js-accordion-header').length > 0) {
  document.querySelectorAll('.js-accordion-header').forEach(header => {
    header.addEventListener('click', () => {
      const parentItem = header.closest('.js-accordion-item');
      const content = parentItem.querySelector(':scope > .js-accordion-content');

      if (!content) return;

      const isOpen = isVisible(content);

      // 👇 Detect level (main vs sub)
      const isSubLevel = parentItem.closest('.mobile-menu__content') !== null;

      if (isOpen) {
        slideUp(content, duration, parentItem);
      } else {

        if (isSubLevel) {
          // 👉 ONLY close siblings inside same parent (collections level)
          const siblings = parentItem.parentElement.querySelectorAll(':scope > .js-accordion-item');

          siblings.forEach(el => {
            if (el !== parentItem) {
              const elContent = el.querySelector(':scope > .js-accordion-content');
              if (elContent && isVisible(elContent)) {
                slideUp(elContent, duration, el);
              }
            }
          });

        } else {
          // 👉 MAIN LEVEL: close other main accordions
          document.querySelectorAll('.mobile-menu > .js-accordion-item').forEach(el => {
            if (el !== parentItem) {
              const elContent = el.querySelector(':scope > .js-accordion-content');
              if (elContent && isVisible(elContent)) {
                slideUp(elContent, duration, el);
              }
            }
          });
        }

        slideDown(content, duration, parentItem);
      }
    });
  });
}

// JS Accordion Swiper
if (('.js-header-swiper').length > 0) {
  const swiper = new Swiper('.js-header-swiper', {
    loop: false,
    slidesPerView: 2.1,
    spaceBetween: 12,
    navigation: {
      nextEl: '.header-detail-next',
      prevEl: '.header-detail-prev'
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 24,
      },
      992: {
        slidesPerView: 3.5,
        spaceBetween: 24,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 24,
      },
    }
  });
}



// Essentials section JS
document.addEventListener("DOMContentLoaded", function () {
  const partnerSlider = new Swiper('.js-partner-slider', {
    loop: true,
    slidesPerView: 3.5,
    loopAdditionalSlides: 5,
    autoplay: {
      delay: 0,
    },
    speed: 3000,
    breakpoints: {
      767: {
        slidesPerView: 'auto'
      }
    }
  });

  const ugcSlider = new Swiper('.js-ugc-slider', {
    loop: true,
    slidesPerView: 'auto',
    loopAdditionalSlides: 5,
    autoplay: {
      delay: 0,
    },
    speed: 3000,
  });


  const videoSectionSlider = new Swiper('.js-review-swiper', {
    loop: false,
    slidesPerView: 1.66,
    spaceBetween: 16,
    breakpoints: {
      475: {
        slidesPerView: 1.5,
      },
      640: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
      991: {
        slidesPerView: 2.5,
        spaceBetween: 16,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 16,
      },
    },
    pagination: {
      el: '.video-slider-pagination',
      clickable: true
    }
  });

  const realStoriesSwiper = new Swiper('.js-eq-stories-swiper', {
    loop: true,
    slidesPerView: 1.17,
    speed: 1000,
    spaceBetween: 3,
    centeredSlides: true,
    pagination: {
      el: '.real-stories-pagination',
      clickable: true
    },
    breakpoints: {
      767: {
        slidesPerView: 2,
        spaceBetween: 12,
      },
      991: {
        loop: false,
        slidesPerView: 3,
        centeredSlides: false,
        spaceBetween: 12,

      }
    }
  });

  // Shop By Essentials Section
  document.querySelectorAll(".eq-health__toggle").forEach(toggleContainer => {
    const buttons = toggleContainer.querySelectorAll(".eq-toggle__button button");
    const parent = toggleContainer.parentElement;
    const sections = Array.from(parent.querySelectorAll("[data-attr]"))
      .filter(sec => !toggleContainer.contains(sec)); // exclude the toggle itself

    sections.forEach((sec, i) => {
      sec.style.display = i === 0 ? "block" : "none";
    });

    buttons.forEach(btn => {
      btn.addEventListener("click", function () {
        buttons.forEach(b => b.classList.remove("active"));
        this.classList.add("active");

        const target = this.getAttribute("data-attr");
        sections.forEach(sec => {
          sec.style.display = sec.getAttribute("data-attr") === target ? "block" : "none";
        });
      });
    });
  });

  // Footer Accordion
  document.querySelectorAll('.eq-footer__links-section .js-show-footer-links').forEach(accordion => {
    accordion.addEventListener('click', () => {
      const parent = accordion.parentElement;
      const ul = parent.querySelector('ul');
      const allSections = document.querySelectorAll('.eq-footer__links-section');

      if (parent.classList.contains('open')) {
        ul.style.maxHeight = ul.scrollHeight + "px";
        requestAnimationFrame(() => {
          ul.style.maxHeight = "0";
        });
        parent.classList.remove('open');
      } else {
        // Close all other sections
        allSections.forEach(section => {
          if (section !== parent && section.classList.contains('open')) {
            const otherUl = section.querySelector('ul');
            otherUl.style.maxHeight = otherUl.scrollHeight + "px";
            requestAnimationFrame(() => {
              otherUl.style.maxHeight = "0";
            });
            section.classList.remove('open');
          }
        });

        // Open current one
        ul.style.maxHeight = ul.scrollHeight + "px";
        parent.classList.add('open');
        ul.addEventListener("transitionend", () => {
          if (parent.classList.contains('open')) {
            ul.style.maxHeight = "none";
          }
        }, { once: true });
      }
    });
  });

  // Product Slider Init
  let mainProductSliderWrap = document.querySelectorAll(".product-details__slider-wrap");

  let productNavSlider = document.querySelector('.js-main-product-swiper');
  let productThumbnailSlider = document.querySelector('.js-product-details-thumbnail-slider');

  if ((!productNavSlider && productNavSlider === null) && (!productThumbnailSlider && productThumbnailSlider === null)) return;

  let productNavSliderConfig, productThumbnailSliderConfig;

  productThumbnailSliderConfig = new Swiper(productThumbnailSlider, {
    loop: false,
    speed: 500,
    spaceBetween: 8,
    slidesPerView: 5.5,
    freeMode: true,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    pagination: false,
    direction: "horizontal",
    breakpoints: {
      1200: {
        spaceBetween: 11,
        slidesPerView: 6,
      },
      992: {
        spaceBetween: 12,
      },
      768: {
        spaceBetween: 11,
      }
    },
    on: {
      init: function () {
        productThumbnailSlider.style.visibility = 'visible';
        productThumbnailSlider.style.opacity = 1;
      }
    }
  });


  productNavSliderConfig = new Swiper(productNavSlider, {
    loop: false,
    spaceBetween: 10,
    slidesPerView: 1,
    autoplay: false,
    speed: 500,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    grabCursor: true,
    autoHeight: true,
    thumbs: {
      swiper: productThumbnailSliderConfig,
    },
    pagination: {
      el: '.product-details-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.product-detail-next',
      prevEl: '.product-detail-prev'
    },
    breakpoints: {
      992: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 1,
      }
    },
  });


  // Key benefits JS
  let isMobile = window.matchMedia("(max-width: 991px)").matches;
  let jsKeyBenefitsHeader = document.querySelectorAll('.js-key-benefits-header');


  function handleClick(e) {
    const tabId = e.target.dataset.tab;
    const parent = e.target.closest('.js-tab-item');

    // if the default is open, convert it into normal "is-open" only once
    const defaultParent = document.querySelector('.js-tab-item.is-open-default');
    if (defaultParent && defaultParent !== parent) {
      const openPanel = defaultParent.querySelector('.tab-content__main');
      slideUp(openPanel, 300, defaultParent);
    }


    if (isMobile) {
      const panel = parent.querySelector('.tab-content__main');
      if (!panel) return;

      if (isVisible(panel)) {
        slideUp(panel, 300, parent);
      } else {
        document.querySelectorAll('.js-tab-item.is-open').forEach(openItem => {
          if (openItem !== parent) {
            const openPanel = openItem.querySelector('.tab-content__main');
            slideUp(openPanel, 300, openItem);
          }
        });
        slideDown(panel, 300, parent);
      }
    } else {
      const allPanels = document.querySelectorAll('.tab-content__main');
      const newPanel = document.querySelector(`.js-tab-item[data-tab="${tabId}"] .tab-content__main`);

      allPanels.forEach(p => p.classList.remove('active'));
      newPanel.classList.add('active');

      jsKeyBenefitsHeader.forEach(btn => btn.classList.remove('active'));
      e.target.classList.add('active');
    }
  }




  jsKeyBenefitsHeader.forEach(header =>
    header.addEventListener('click', handleClick)
  );

  window.addEventListener('resize', () => {
    isMobile = window.matchMedia("(max-width: 991px)").matches;
  });


  // PDP Page Swiper
  const ingrediantsBreakdown = new Swiper('.js-ingredient-breakdown-swiper', {
    loop: false,
    slidesPerView: 1.2,
    loopAdditionalSlides: 5,
    spaceBetween: 12,
    pagination: {
      el: '.swiper-ingredients-pagination',
      clickable: true
    },
    navigation: {
      prevEl: '.ingredient-breakdown-prev',
      nextEl: '.ingredient-breakdown-next',
    },
    breakpoints: {
      767: {
        slidesPerView: 1,
      }
    }
  });

  // Daily steps Slide 
  const dailyStepsSlide = new Swiper('.js-daily-steps-swiper', {
    loop: false,
    slidesPerView: 1.1,
    loopAdditionalSlides: 5,
    spaceBetween: 12,
    pagination: {
      el: '.js-daily-steps-pagination',
      clickable: true
    },

    breakpoints: {
      767: {
        slidesPerView: 2,
      },
      991: {
        slidesPerView: 2.2,
      },
      1024: {
        slidesPerView: 3,
      },
    }
  });

  // Recipes Swiper
  const recipesSwiper = new Swiper('.js-recipes-swiper', {
    loop: false,
    slidesPerView: 1.2,
    loopAdditionalSlides: 5,
    spaceBetween: 12,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    centeredSlides: false,
    pagination: {
      el: '.js-recipes-pagination',
      clickable: true
    },

    breakpoints: {
      767: {
        slidesPerView: 2,
        centeredSlides: false,
        spaceBetween: 24,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 24,
        centeredSlides: false,
      }
    }
  });


  // Product Section Slider 
  const productSlider = new Swiper('.js-product-swiper', {
    loop: false,
    slidesPerView: 2.05,
    spaceBetween: 12,
    centeredSlides: false,
    pagination: {
      el: '.js-product-slider-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.js-product-nav-next',
      prevEl: '.js-product-nav-prev'
    },
    breakpoints: {
      767: {
        slidesPerView: 2,
        centeredSlides: false,
        spaceBetween: 24,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 12,
        centeredSlides: false,
      }
    }
  });

  document.addEventListener("click", function (e) {
    const dropdown = document.querySelector(".eq-collection-prod-filter");
    const switchInput = dropdown.querySelector(".dropdown__switch");

    if (!dropdown.contains(e.target)) {
      switchInput.checked = false;
    }
  });



  // For matching The Heights


});

function matchHeights(selector) {
  const elements = document.querySelectorAll(selector);
  let maxHeight = 0;
  elements.forEach(el => {
    el.style.height = "auto";
  });

  // Find tallest height
  elements.forEach(el => {
    if (el.offsetHeight > maxHeight) {
      maxHeight = el.offsetHeight;
    }
  });

  elements.forEach(el => {
    el.style.height = maxHeight + "px";
  });
}

matchHeights(".eq-collection__row .eq-product__sub .eq-button");

window.addEventListener("resize", () => {
  matchHeights(".eq-collection__row .eq-product__sub .eq-button");
});

const collectionDropdownSelected = document.querySelector(".dropdown__filter-selected");
const sortBySelect = document.getElementById("SortBy");
const customOptions = document.querySelectorAll(".dropdown__select-option");
const switchInput = document.querySelector(".dropdown__switch");

if (sortBySelect && collectionDropdownSelected && switchInput) {
  const currentValue = sortBySelect.value;
  const activeOption = Array.from(customOptions).find(
    opt => opt.getAttribute("data-value") === currentValue
  );
  if (activeOption) {
    customOptions.forEach(opt => opt.classList.remove("active"));
    activeOption.classList.add("active");
    collectionDropdownSelected.textContent = activeOption.textContent;
  }

  customOptions.forEach(option => {
    option.addEventListener("click", () => {
      const value = option.getAttribute("data-value");
      sortBySelect.value = value;

      sortBySelect.dispatchEvent(new Event("change"));

      collectionDropdownSelected.textContent = option.textContent;

      customOptions.forEach(opt => opt.classList.remove("active"));
      option.classList.add("active");
    });
  });

  sortBySelect.addEventListener("change", (e) => {
    setTimeout(() => {
      switchInput.checked = false;
    }, 0);
  });

  document.addEventListener("click", function (e) {
    const dropdown = document.querySelector(".dropdown");
    if (dropdown && !dropdown.contains(e.target)) {
      switchInput.checked = false;
    }
  });
}



// Video Section Slider


const videoWrappers = document.querySelectorAll('.review-slide__video');
const allVideos = document.querySelectorAll('.review-slide__video video');

videoWrappers.forEach(wrapper => {
  const playButton = wrapper.querySelector('.js-play-review-video');
  const video = wrapper.querySelector('video');

  playButton.addEventListener('click', () => {
    allVideos.forEach(otherVideo => {
      if (otherVideo !== video) {
        otherVideo.pause();
        const otherBtn = otherVideo.closest('.review-slide__video')
          .querySelector('.js-play-review-video');
        otherBtn.style.display = 'block';
      }
    });

    playButton.style.display = 'none';
    video.play();
  });
  video.addEventListener('click', () => {
    video.pause();
    playButton.style.display = 'block';
  });
  video.addEventListener('pause', () => {
    playButton.style.display = 'block';
  });

  video.addEventListener('ended', () => {
    playButton.style.display = 'block';
  });
});

function pauseAllExcept(currentVideo) {
  allVideos.forEach(otherVideo => {
    if (otherVideo !== currentVideo) {
      otherVideo.pause();
      const otherBtn = otherVideo.closest('.review-slide__video')
        .querySelector('.js-play-review-video');
      otherBtn.style.display = 'block';
    }
  });
}

const videoWrap = document.querySelector('.eq-mission__video');

if (videoWrap) {
  const video = videoWrap.querySelector('video');
  const playBtn = videoWrap.querySelector('.js-play-video');

  playBtn.addEventListener('click', () => {
    if (video.paused) {
      video.play();
      playBtn.style.display = 'none';
    } else {
      video.pause();
      playBtn.style.display = 'block';
    }
  });

  video.addEventListener('click', () => {
    if (!video.paused) {
      video.pause();
      playBtn.style.display = 'block';
    }
  });

  video.addEventListener('ended', () => {
    playBtn.style.display = 'block';
  });
}



const checkoutBtns = $('[name="checkout-firmhouse"]');
if (checkoutBtns.length > 0) {

  const checkoutBtnOriginal = document.querySelector('[name="checkout"]');

  for (const checkoutBtn of checkoutBtns) {
    console.log(checkoutBtn);
    checkoutBtn.addEventListener('click', async function (event) {
      event.preventDefault();

      const redirectLinkPromise = new Promise((resolve, reject) => {
        fetch(window.Shopify.routes.root + 'cart.js')
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            const items = data.items;
            let toFirmhouse = false;

            for (const item of items) {
              if (item.properties && item.properties['_subscription'] && item.properties['_subscription'] === 'true') {
                toFirmhouse = true;
                break;
              }
            }

            if (!toFirmhouse) {
              resolve('');
            }

            const rootURL = "https://superfoodies.nl/go/abonnement";
            const queryItems = items.map(function (item) {
              let id = item.id;


              if (item.properties && item.properties['_plans']) {
                let frequency = 'een keer';

                if (item.properties['_subscription'] && item.properties['_subscription'] === 'true')
                  frequency = item.properties['_frequency'] || 'een keer';

                const base = JSON.parse(atob(item.properties['_plans']));

                id = base[frequency];
              }

              return `ordered_products[${id}]=${item.quantity}`;
            }).join('&');

            resolve(`${rootURL}?${queryItems}`);
          }).catch(function (error) {
            reject(error);
          });
      });

      const singleItemsPromise = new Promise((resolve, reject) => {
        fetch(`${window.Shopify.routes.root}?sections=main-cart-items`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json"
          }
        })
          .then(res => res.json())
          .then(resJson => {
            var htmlObject = document.createElement('div');
            htmlObject.innerHTML = resJson['main-cart-items'];

            const sidecartItems = htmlObject.querySelector('.cart-items-wrp');
            const singleItems = [];
            const productItems = sidecartItems.querySelectorAll('.cart-item');

            if (productItems.length > 0) {
              for (const item of productItems) {
                if (item.hasAttribute('data-fh-once-id') && item.hasAttribute('data-fh-quantity')) {
                  singleItems.push({
                    id: item.getAttribute('data-fh-once-id'),
                    quantity: item.getAttribute('data-fh-quantity')
                  });
                }
              }

              const queryItems = singleItems.map(function (id) {
                return `ordered_products[${id.id}]=${id.quantity}`;
              })
              resolve(queryItems);
            } else {
              resolve('');
            }
          }).catch(error => {
            reject(error);
          });
      });

      const [redirectLink, singleItems] = await Promise.all([redirectLinkPromise, singleItemsPromise]);

      if (redirectLink !== '') {
        let finalLink = redirectLink;

        if (singleItems !== '') {
          finalLink += '&' + singleItems.join('&');
        }

        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (isSafari && /iP(hone|od|ad)/.test(navigator.userAgent)) {
          const a = document.createElement('a');
          a.href = finalLink;
          a.style.display = 'none';
          a.rel = 'nofollow';
          a.target = '_self';
          document.body.appendChild(a);
          a.click();
          a.remove();
        } else {
          window.location.href = finalLink;
        }

      } else {
        checkoutBtnOriginal.click();
      }
    });

  }
}




function time_cal() {
  const spans = document.querySelectorAll('.how_much_time');

  spans.forEach(async span => {
    const url = span.dataset.url;

    if (!url) return;

    try {
      const res = await fetch(url);
      const html = await res.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const article = doc.querySelector('.article');
      if (!article) {
        span.textContent = "Read time N/A";
        return;
      }

      var read = '';
      if (span.classList.contains('with_read')) {
        read = "read";
      }

      const text = article.innerText || "";
      const wordCount = text.trim().split(/\s+/).length;
      const readingTime = Math.max(1, Math.ceil(wordCount / 200));
      const wordsPerMinute = 200;
      const minutes = wordCount / wordsPerMinute;
      if (minutes < 1) {
        const seconds = Math.max(1, Math.round(minutes * 60));
        span.textContent = `${seconds} secs ${read}`;
      } else {
        const readingTime = Math.ceil(minutes);
        span.textContent = `${readingTime} mins ${read}`;
      }
      // span.textContent = `${readingTime} min`;
    } catch (err) {
      console.error("Reading time error:", err);
      span.textContent = "Read time N/A";
    }
  });
}

if ($('.how_much_time').length > 0) {
  time_cal();
}



// Similar Recipes Swiper
const similar_recipesSwiper = new Swiper('.js-similar-recipes-swiper', {
  loop: false,
  slidesPerView: 1.2,
  loopAdditionalSlides: 5,
  spaceBetween: 12,
  centeredSlides: false,
  pagination: {
    el: '.js-recipes-pagination',
    clickable: true
  },

  breakpoints: {
    767: {
      slidesPerView: 2,
      centeredSlides: false,
      spaceBetween: 24,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 24,
      centeredSlides: false,
    }
  }
});